<!--
  Верстка адаптирована из шаблона:
  Файл: design-assets/themeforest_4DdWBZd0_education_online_courses_template_istudy (1)/istudy/courses-details.html
  Компонент: bd-course-sidebar-widget-thumb (строки 1359-1366)
  Стили: design-assets/themeforest_4DdWBZd0_education_online_courses_template_istudy (1)/istudy/assets/css/main.css
  Классы: .bd-course-sidebar-widget-thumb (строка 18712)
-->
<template>
  <div class="course-cover">
    <div class="cover-image">
      <img :src="imageUrl || '/images/default-course.jpg'" :alt="title">
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  title: string
  lessonsAmount?: number
  imageUrl?: string
}

defineProps<Props>()
</script>

<style scoped>
.course-cover {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  aspect-ratio: 280 / 411;
  width: 100%;
}

.cover-image {
  position: absolute;
  inset: 0;
}

.cover-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

</style>
